import { observer } from "mobx-react-lite";

import { twMerge } from "@/utils/twMerge";

import { InlineNode } from "./InlineNode";

import type { ExpressionComponent } from "./types";

export const LabelNode: ExpressionComponent<"label"> = observer(function LabelNode({
  className,
  node,
}) {
  if (node.inlineNode) {
    return <InlineNode node={node.inlineNode} className={twMerge("flex", className)} />;
  }

  return null;
});
